import React from 'react';
import {
  MobileList, MobileListEmpty, MobileListSkeleton, MobileRow, StatusPill, initialsOf,
} from '../kit';

const plural = (n, word) => `${n ?? '—'} ${word}${n === 1 ? '' : 's'}`;

/** Short pill label for the phone row; the state logic is refreshModel's. */
export const phoneRefreshLabel = (state) => (state.key === 'ok' ? 'Refreshed' : state.label);

/** "Next 02:00" for set times, "Every hour" for intervals, nothing when off. */
export const phoneNextRun = (next) => {
  if (next?.time) return `Next ${next.time}`;
  if (next?.mode === 'interval') return next.label;
  return null;
};

/**
 * Phone version of the organizations table: one card per org, tap → detail.
 *   rows [{ org, state, next }] (already filtered) · onOpen(id)
 *   empty: { title, body, action } | null
 */
export default function OrgCardList({ rows, loading, empty, onOpen }) {
  return (
    <MobileList label="Organizations">
      {loading ? <MobileListSkeleton rows={6} /> : null}
      {!loading && empty ? <MobileListEmpty title={empty.title} body={empty.body} action={empty.action} /> : null}
      {!loading && rows.map(({ org, state, next }) => {
        const name = org.name || 'Unnamed organization';
        const nextLabel = phoneNextRun(next);
        return (
          <MobileRow
            key={org.id}
            onClick={() => onOpen(org.id)}
            lead={<span className="ak-m-mark" aria-hidden="true">{initialsOf(org.name || org.code)}</span>}
            title={name}
            sub={(
              <span className="ak-m-shrink">
                {plural(org.locationCount, 'location')} · {plural(org.userCount, 'user')} · <span className="ak-mono">{org.reportingCurrency || 'USD'}</span>
              </span>
            )}
            aside={(
              <>
                <StatusPill tone={state.tone} running={state.key === 'running'} title={state.errorText || state.detail}>
                  {phoneRefreshLabel(state)}
                </StatusPill>
                {nextLabel ? <span className="ak-mono">{nextLabel}</span> : null}
              </>
            )}
          />
        );
      })}
    </MobileList>
  );
}
